import React, { useState } from "react";
import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { useRateLabels } from "@/hooks/useRateLabels";
import { useUnitItemContext } from "@/hooks/useUnitItemContext";
import type { UnitRates } from "@/types";
import { useFacilitiesContext } from "@/hooks/useFacilitiesContext";

interface UnitPriceProps {
    rates: UnitRates;
}

export const UnitPrice = ({ rates }: UnitPriceProps) => {
    const { selectedPromo, unitGroup } = useUnitItemContext();
    const { showAppliedPromotionPrice} = useDisplayOptionContext();
    const { display_rate, strike_through_rate, promo_rates = [] } = rates;

    const { facilities } = useFacilitiesContext();
    const [selectedFacility] = useState(facilities.find( facility => facility.id === unitGroup.representative_unit.facility_id));

    const hideCents = selectedFacility?.settings?.remove_cents_from_rate

    const selectedPromoRate = promo_rates.find(
        (element) => element.id === selectedPromo,
    )?.rate;

    const {
        promoRate: promoRateLabel,
        webRate: webRateLabel,
        strikeThroughRate: strikeThroughRateLabel
    } = useRateLabels(unitGroup.representative_unit.facility_id);

    const shouldShowPromoRate = showAppliedPromotionPrice && selectedPromoRate != null;
    const hasStrikeThroughRate = strike_through_rate != null;
    const strinkenThroughRate = hasStrikeThroughRate ? strike_through_rate : display_rate;

    return (
        <div className="unit-item-price tw:text-center">
            {/* Display Promo Rate if applicable */}
            {shouldShowPromoRate && (
                <div className="unit-item-price__promo-rate">
                    <span className="unit-item-price__label">{promoRateLabel} </span>$
                    {hideCents
                        ? selectedPromoRate
                        : selectedPromoRate.toFixed(2)
                    }
                </div>
            )}

            {/* Display Web Rate if there's a difference or no Promo Rate */}
            {!shouldShowPromoRate ? (
                <div className="unit-item-price__web-rate">
                    <span className="unit-item-price__label">{webRateLabel} </span>$
                    { hideCents ? display_rate : display_rate.toFixed(2) }
                </div>
            ) : null}

            {/* Display Strike Through Rate if applicable */}
            {(hasStrikeThroughRate || shouldShowPromoRate )&& (
                <div className="unit-item-price__strike-through-rate tw:text-sm tw:line-through">
                    <span className="unit-item-price__label">{strikeThroughRateLabel} </span>$
                    { hideCents ? strinkenThroughRate : strinkenThroughRate.toFixed(2) }
                </div>
            )}
        </div>
    );
};